import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import {
  Person, AccessTime, Speed, VpnKey, LocationOn, DirectionsCar, VpnKeyOff, LocationOff,
} from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Paper } from '@mui/material';
import { devicesActions } from '../../store';
import { useTranslation } from './LocalizationProvider';
import sedanSvg from '../../resources/images/icon/vehicle-categories/sedan.svg';
import suvSvg from '../../resources/images/icon/vehicle-categories/suv.svg';
import pickupTruckSvg from '../../resources/images/icon/vehicle-categories/pickup-truck.svg';
import vanSvg from '../../resources/images/icon/vehicle-categories/van.svg';
import busSvg from '../../resources/images/icon/vehicle-categories/bus.svg';
import boxTruckSvg from '../../resources/images/icon/vehicle-categories/truck.svg';
import trailerTruckSvg from '../../resources/images/icon/vehicle-categories/trailer.svg';

const useStyles = makeStyles({
  container: {
    borderRadius: '10px',
    background: 'rgba(0, 0, 0, 0.8)',
    minHeight: '80px',
    cursor: 'pointer',
    marginTop: '10px',
    marginBottom: '10px',
    color: 'white',
    textAlign: 'center',
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    display: 'flex',
  },
  logo: {
    width: '10%',
    placeSelf: 'center',
  },
  data: {
    width: '90%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gap: '10px',
    paddingLeft: '10px',
    alignSelf: 'center',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  pl1: {
    paddingLeft: '10px',
  },
  vehicleLogo: {
    maxHeight: '50px',
  },
});

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);

  const formattedDate = formatter.format(date);
  return formattedDate;
};

const getImageByVehicleCategory = (category) => {
  switch (category) {
    case 'Sedan':
      return sedanSvg;
    case 'SUV':
      return suvSvg;
    case 'Pickup Truck':
      return pickupTruckSvg;
    case 'Van':
      return vanSvg;
    case 'Bus':
      return busSvg;
    case 'Box Truck':
      return boxTruckSvg;
    case 'Trailer Truck':
      return trailerTruckSvg;
    default:
      return sedanSvg;
  }
};

const isWithinMinutes = (fixTime, minutes) => {
  const minutesAgo = new Date(Date.now() - minutes * 60 * 1000);
  return new Date(fixTime) >= minutesAgo;
};

const VehicleDataCard = ({ data }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const t = useTranslation();
  return (
    <Paper className={classes.container} onClick={() => dispatch(devicesActions.select(data.id))}>
      <div className={classes.logo}>
        <img className={classes.vehicleLogo} src={getImageByVehicleCategory(data.vehicleCategory)} alt="vehicle" />
      </div>
      <div className={classes.data}>
        <div className={classes.item}>
          <DirectionsCar />
          <span className={classes.pl1}>{data.vehicleName}</span>
        </div>
        <div className={classes.item}>
          <Person />
          <span className={classes.pl1}>{data.driverName}</span>
        </div>
        <div className={classes.item}>
          {isWithinMinutes(data.fixTime, 10) ? <LocationOn /> : <LocationOff />}
          <span className={classes.pl1}>
            {t('positionGps')}
            &nbsp;
            {isWithinMinutes(data.fixTime, 10) ? 'ON' : 'OFF'}
          </span>
        </div>
        <div className={classes.item}>
          {data.ignition ? <VpnKey /> : <VpnKeyOff />}
          <span className={classes.pl1}>
            {t('positionIgnition')}
            &nbsp;
            {data.ignition ? 'ON' : 'OFF'}
          </span>
        </div>
        <div className={classes.item}>
          <Speed />
          <span className={classes.pl1}>{data.speed}</span>
        </div>
        <div className={classes.item}>
          <AccessTime />
          <span className={classes.pl1}>{formatDate(data.fixTime)}</span>
        </div>
      </div>
    </Paper>
  );
};

export default VehicleDataCard;
